import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// ---- Component ----

const Login = () => {
	return (
		<Container>
			<CTA>
				<CTALogoOne alt="" src="/images/cta-logo-one.svg" />
				<SignUp to="/home">GET ALL THERE</SignUp>
				<Description>
					Get Premier Access to Raya and the Last Dragon for an additional fee
					with a Disney+ subscription. As of 03/26/21, the price of Disney+ and
					The Disney Bundle will increase by $1.
				</Description>
				<CTALogoTwo alt="" src="/images/cta-logo-two.png" />
			</CTA>
		</Container>
	);
};

export default Login;

// ---- Style ----

const Container = styled.div`
	// height: calc(100vh - 70px);
	height: 100vh;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;

	&:before {
		background-position: top;
		background-size: cover;
		background-repeat: no-repeat;
		background-image: url("/images/login-background.jpg");
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		opacity: 0.7;
		z-index: -1;
	}
`;

const CTA = styled.div`
	width: 90%;
	max-width: 700px;
	padding: 80px 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const CTALogoOne = styled.img``;

const SignUp = styled(Link)`
	width: 100%;
	background-color: #0063e5;
	font-weight: bold;
	padding: 17px 0;
	color: #f9f9f9;
	border-radius: 4px;
	text-align: center;
	font-size: 18px;
	cursor: pointer;
	transition: all 250ms;
	letter-spacing: 1.5px;
	margin-top: 8px;
	margin-bottom: 12px;
	text-decoration: none;

	&:hover {
		background-color: #0483ee;
	}
`;

const Description = styled.p`
	font-size: 11px;
	letter-spacing: 1.5px;
	text-align: center;
	line-height: 1.5;
`;

const CTALogoTwo = styled.img`
	width: 90%;
`;
